import { MtUser } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { UserFilters } from "client/store"
import * as types from "./types"


export const setTaskObserverList = (taskObserverList: types.TaskObserverList) => ({
    type: inferLiteral(types.TASK_OBSERVER_LIST),
    taskObserverList,
})
export const setNotAssignedTaskObserverIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_OBSERVER_IDS),
    userIds,
})
export const setNotAssignedTaskObserverSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_OBSERVER_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedTaskObserverFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_OBSERVER_FILTERS),
    filters,
})
export const setNotAssignedTaskObserverSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_TASK_OBSERVER_SELECTED),
    selected,
})
